import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
function SkeletonLine({ width = "100%", height = 18 }) {
  return <Skeleton variant="text" width={width} height={height} sx={{ borderRadius: "4px" }} />;
}

function SkeletonChip({ width = 72 }) {
  return (
    <Skeleton variant="rounded" width={width} height={24} sx={{ borderRadius: "20px" }} />
  );
}
export function AgentAddModalFormSkeleton() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {[1, 2, 3, 4].map((i) => (
        <Box key={i}>
          <Skeleton variant="text" width={60} height={14} sx={{ mb: 0.75 }} />
          <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: "8px" }} />
        </Box>
      ))}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Skeleton variant="rounded" width="50%" height={40} sx={{ borderRadius: "8px" }} />
        <Skeleton variant="rounded" width="50%" height={40} sx={{ borderRadius: "8px" }} />
      </Box>
    </Box>
  );
}

export function AgentSidebarSkeleton() {
  return (
    <Box sx={{ flex: 1, overflowY: "auto", px: 2, py: 1.5, marginBottom:"200px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 2 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="70%" height={18} />
          <Skeleton variant="text" width="50%" height={14} sx={{ mt: 0.5 }} />
        </Box>
      </Box>
      {[1, 2 ,3].map((i) => (
        <Box key={i} sx={{ py: 1.5, borderBottom: "1px solid #EEF2F6" }}>
          <Skeleton variant="text" width={120} height={16} sx={{ mb: 1.5 }} />
          <Skeleton variant="text" width="90%" height={14} />
          <Skeleton variant="text" width="60%" height={14} sx={{ mt: 1 }} />
        </Box>
      ))}
       {[1, 2, 3].map((i) => (
          <Box key={i} sx={{ py: 1.5, borderBottom: "1px solid #EEF2F6" }}>
            <SkeletonLine width={80} height={16} />
            <Box sx={{ display: "flex", gap: 0.75, mt: 1 }}>
              <SkeletonChip />
              <SkeletonChip />
              <SkeletonChip />
              <SkeletonChip />
            </Box>
          </Box>
        ))}
    </Box>
  );
}

export function AgentFormFieldSkeleton() {
  return <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: "8px" }} />;
}

export function AgentEditPageSkeleton() {
  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 3, py: 3, bgcolor: "#FFF" }}>
      <Box sx={{ maxWidth: 632, width: "100%", mx: "auto" }}>
        <Skeleton variant="text" width={160} height={32} sx={{ borderRadius: "4px" }} />
        <Skeleton variant="text" width="70%" height={18} sx={{ borderRadius: "4px", mt: 1, mb: 3 }} />
        {[1, 2, 3, 4, 5].map((i) => (
          <Box key={i} sx={{ mb: 2 }}>
            <Skeleton variant="text" width={60} height={14} sx={{ mb: 0.75 }} />
            <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: "8px" }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export function AgentDetailPageSkeleton() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "#FFF",
      }}
    >
      <Box sx={{ bgcolor: "#FFF", px: 3, py: 2, borderBottom: "1px solid #E5E9EC", flexShrink: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Skeleton variant="circular" width={56} height={56} />
          <Box>
            <Skeleton variant="text" width={180} height={28} sx={{ borderRadius: "4px" }} />
            <Skeleton variant="text" width={120} height={18} sx={{ borderRadius: "4px", mt: 0.5 }} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ flex: 1, overflowY: "auto", pt: "32px", px: 3, pb: 3 }}>
        <Box sx={{ maxWidth: 632, width: "100%", mx: "auto" }}>
          <Skeleton variant="text" width={140} height={28} sx={{ borderRadius: "4px", mb: 1.5 }} />
          <Skeleton variant="rounded" width="100%" height={344} sx={{ borderRadius: "8px", mb: 3 }} />
          <Skeleton variant="text" width={160} height={28} sx={{ borderRadius: "4px", mb: 1.5 }} />
          <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: "8px", mb: 3 }} />
          <Skeleton variant="text" width={180} height={28} sx={{ borderRadius: "4px", mb: 1.5 }} />
          <Skeleton variant="rounded" width="100%" height={140} sx={{ borderRadius: "8px" }} />
        </Box>
      </Box>
    </Box>
  );
}
